import createMuiTheme from 'material-ui/styles/createMuiTheme';

export const energyBox = {
  50: '#e0f2f1',
  100: '#b2dfdb',
  200: '#80cbc4',
  300: '#4db6ac',
  400: '#26a69a',
  500: '#009688', // '#009688', // #48c3b1
  600: '#00897b',
  700: '#00796b',
  800: '#00695c',
  900: '#004d40',
  A100: '#a7ffeb',
  A200: '#64ffda',
  A400: '#1de9b6',
  A700: '#00bfa5',
  contrastDefaultColor: 'dark'
};

export const ghub = {
  50: '#e0f3fb',
  100: '#b3e2f6',
  200: '#80CFF1',
  300: '#4dbbeb',
  400: '#26ace6',
  500: '#009ee2',
  600: '#0185be',
  700: '#134a69',
  800: '#062b3e',
  900: '#071f2c',
  A100: '#4fb3e8',
  A200: '#0a83b6',
  A400: '#00559b',
  A700: '#002f57',
  contrastDefaultColor: 'light'
};

export const defaultTheme = createMuiTheme({
  palette: {
    primary: energyBox
  },
  appBarBg: '#333'
});

export const darkTheme = createMuiTheme({
  palette: {
    primary: ghub,
    type: 'dark'
  }
});



// WEBPACK FOOTER //
// ./src/themes/themes.js